// Labor cost helpers used by Roster and dashboard chart.
export function minutesBetween(startHHmm, endHHmm) {
  if (!startHHmm || !endHHmm) return 0;
  const [sh, sm] = startHHmm.split(":").map(Number);
  const [eh, em] = endHHmm.split(":").map(Number);
  let mins = eh * 60 + em - (sh * 60 + sm);
  if (mins < 0) mins += 24 * 60; // overnight
  return mins;
}

export function computeShiftCost(shift, staffById) {
  const staff = staffById[shift.staff_id];
  const rate = shift.hourly_rate_override ?? staff?.hourly_rate ?? 0;
  const totalMinutes = minutesBetween(shift.start_time, shift.end_time) - (shift.break_minutes || 0);
  const hours = Math.max(totalMinutes, 0) / 60;
  return { staff, hours, rate, cost: hours * rate };
}

export function totalLaborCost(shifts, staffById) {
  return shifts.reduce((sum, s) => sum + computeShiftCost(s, staffById).cost, 0);
}

export function totalLaborHours(shifts, staffById) {
  return shifts.reduce((sum, s) => sum + computeShiftCost(s, staffById).hours, 0);
}

export function avgHourlyRate(staffList) {
  const active = staffList.filter((s) => s.active !== false);
  if (!active.length) return 0;
  return active.reduce((s, x) => s + (x.hourly_rate || 0), 0) / active.length;
}

// Week helpers: Monday start.
export function startOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = (day + 6) % 7; // Mon = 0
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function isoDate(date) {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Month helpers: grid always begins on a Monday and ends on a Sunday
// so a full 5 or 6 week block covers the target month.
export function startOfMonth(date) {
  const d = new Date(date);
  d.setDate(1);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function endOfMonth(date) {
  const d = new Date(date);
  d.setMonth(d.getMonth() + 1, 0);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function monthGridStart(date) {
  return startOfWeek(startOfMonth(date));
}

export function monthGridDays(date) {
  const start = monthGridStart(date);
  const end = endOfMonth(date);
  // Extend end to the following Sunday so weeks are complete
  const endWeekEnd = addDays(startOfWeek(end), 6);
  const days = [];
  let cur = new Date(start);
  while (cur.getTime() <= endWeekEnd.getTime()) {
    days.push(new Date(cur));
    cur = addDays(cur, 1);
  }
  return days;
}

export function addMonths(date, n) {
  const d = new Date(date);
  d.setMonth(d.getMonth() + n);
  return d;
}
